import React from 'react';
import { twMerge } from 'tailwind-merge';

const EllipsisSeparator = (
  props: React.HTMLAttributes<HTMLDivElement> & { disabled?: boolean }
) => (
  <div
    className={twMerge(
      'flex items-center justify-center w-4 h-12 text-blue-700',
      props.disabled && 'pointer-events-none text-gray-500 bg-gray-200'
    )}
    {...props}
  >
    &hellip;
  </div>
);

export default EllipsisSeparator;
